var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.25 20.25V25.875C11.25 26.1734 11.3685 26.4595 11.5795 26.6705C11.7905 26.8815 12.0766 27 12.375 27H25.9337L31.5 31.5V13.5C31.5 13.2016 31.3815 12.9155 31.1705 12.7045C30.9595 12.4935 30.6734 12.375 30.375 12.375H24.75V19.125C24.75 19.4234 24.6315 19.7095 24.4205 19.9205C24.2095 20.1315 23.9234 20.25 23.625 20.25H11.25Z",
    fill: "#1B1B26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0663 20.25L4.5 24.75V6.75C4.5 6.45163 4.61853 6.16548 4.82951 5.95451C5.04048 5.74353 5.32663 5.625 5.625 5.625H23.625C23.9234 5.625 24.2095 5.74353 24.4205 5.95451C24.6315 6.16548 24.75 6.45163 24.75 6.75V19.125C24.75 19.4234 24.6315 19.7095 24.4205 19.9205C24.2095 20.1315 23.9234 20.25 23.625 20.25H10.0663Z",
    stroke: "#1B1B26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 20.25V25.875C11.25 26.1734 11.3685 26.4595 11.5795 26.6705C11.7905 26.8815 12.0766 27 12.375 27H25.9337L31.5 31.5V13.5C31.5 13.2016 31.3815 12.9155 31.1705 12.7045C30.9595 12.4935 30.6734 12.375 30.375 12.375H24.75",
    stroke: "#1B1B26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIcon);
export default __webpack_public_path__ + "static/media/SMSIcon.06c1d03f070e1c31aa90a99430ea1188.svg";
export { ForwardRef as ReactComponent };